export const SITE = {
  name: "Vmemoo",
  company: "Vmemoo Limited",
  product: "Virtual Memory Space",
  tagline: "Remember people, pets & memories.",
  description: "Vmemoo is a place to preserve stories, remember the people and pets you love, and keep meaningful memories alive.",
  contacts: {
    general: "info@vmemoo.com",
    privacy: "privacy@vmemoo.com",
    copyright: "copyright@vmemoo.com",
    phone: "+353 89 972 8572",
    phoneHref: "tel:+353899728572",
    address: ["77 Camden Street Lower", "Dublin", "D02 XE80", "Ireland"],
  },
  assets: {
    logo: "/assets/vmemoo/brand/vmemoo-logo-transparent.png",
    logoOriginal: "/assets/vmemoo/brand/vmemoo-logo-transparent.png",
    appIcon: "/assets/vmemoo/brand/app-icon.png",
    socialImage: "/assets/vmemoo/social/vmemoo-social-preview.jpg",
    googlePlayBadge: "/assets/vmemoo/store-badges/google-play-badge.png",
    appStoreBadge: "/assets/vmemoo/store-badges/app-store-badge.svg",
  },
  appPromotion: {
    icon: "/assets/vmemoo/brand/vmemoo-app-icon-promotion.jpg",
    dismissStorageKey: "vmemoo-app-promotion-dismissed-until",
    dismissForDays: 30,
  },
  screenshots: {
    artwork: {
      welcome: { src: "/assets/vmemoo/artwork/welcome.png", width: 941, height: 1672, alt: "Vmemoo welcome artwork showing a home for every memory" },
      people: { src: "/assets/vmemoo/artwork/people.png", width: 941, height: 1671, alt: "Vmemoo artwork showing the People memories feed" },
      pets: { src: "/assets/vmemoo/artwork/pets.png", width: 941, height: 1671, alt: "Vmemoo artwork showing the Pets memories feed" },
      memories: { src: "/assets/vmemoo/artwork/memories.png", width: 941, height: 1671, alt: "Vmemoo artwork showing the Memories feed" },
      search: { src: "/assets/vmemoo/artwork/search.png", width: 941, height: 1670, alt: "Vmemoo artwork showing people, pets and memories search" },
      messages: { src: "/assets/vmemoo/artwork/messages.png", width: 941, height: 1670, alt: "Vmemoo artwork showing messages and shared memories" },
      memorials: { src: "/assets/vmemoo/artwork/memorials.png", width: 941, height: 1670, alt: "Vmemoo artwork showing memorial options" },
      stars: { src: "/assets/vmemoo/artwork/stars.png", width: 941, height: 1670, alt: "Vmemoo artwork showing Stars for honouring memories" },
      profile: { src: "/assets/vmemoo/artwork/profile.png", width: 942, height: 1670, alt: "Vmemoo artwork showing a profile and memorial collection" },
      earnStars: { src: "/assets/vmemoo/artwork/earn-stars.png", width: 942, height: 1669, alt: "Vmemoo artwork showing settings, Earn Stars and Memory Quest" },
    },
    memoryQuest: [
      {
        src: "/assets/vmemoo/memory-quest/mq-splash.webp",
        src480: "/assets/vmemoo/memory-quest/mq-splash-480w.webp",
        alt: "Vmemoo Memory Quest welcome screen on mobile",
        caption: "Welcome / begin the journey",
        ratio: 1.992,
      },
      {
        src: "/assets/vmemoo/memory-quest/mq-home.webp",
        src480: "/assets/vmemoo/memory-quest/mq-home-480w.webp",
        alt: "Vmemoo Memory Quest home screen showing Journey progress and Eligible Stars on mobile",
        caption: "Home / track your progress",
        ratio: 1.98,
      },
      {
        src: "/assets/vmemoo/memory-quest/mq-journey.webp",
        src480: "/assets/vmemoo/memory-quest/mq-journey-480w.webp",
        alt: "Vmemoo Memory Quest Journey screen on mobile",
        caption: "Journey / 369 levels to explore",
        ratio: 2.126,
      },
      {
        src: "/assets/vmemoo/memory-quest/mq-achievements.webp",
        src480: "/assets/vmemoo/memory-quest/mq-achievements-480w.webp",
        alt: "Vmemoo Memory Quest Achievements screen on mobile",
        caption: "Achievements / every milestone remembered",
        ratio: 2.117,
      },
    ],
  },
  memoryQuestUrl: "https://play.vmemoo.com",
  storeLinks: {
    ios: null,
    android: "https://play.google.com/store/apps/details?id=com.vmemoo.app",
  },
};

export const PRIMARY_NAV = [
  { label: "About", href: "/#about", id: "about" },
  { label: "How it works", href: "/#how-it-works", id: "how-it-works" },
  { label: "App preview", href: "/#app-preview", id: "app-preview" },
  { label: "Memory Quest", href: "/#memory-quest", id: "memory-quest" },
  { label: "Safety", href: "/#safety", id: "safety" },
  { label: "Updates", href: "/updates", id: "updates" },
];

export const FOOTER_GROUPS = [
  {
    title: "Product",
    links: [
      { label: "Home", href: "/", id: "home" },
      { label: "How it works", href: "/#how-it-works", id: "how-it-works" },
      { label: "App preview", href: "/#app-preview", id: "app-preview" },
      { label: "Updates", href: "/updates", id: "updates" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", href: "/privacy", id: "privacy" },
      { label: "Terms", href: "/terms", id: "terms" },
      { label: "Community guidelines", href: "/community-guidelines", id: "community-guidelines" },
      { label: "Cookie & data use", href: "/cookie-data-use", id: "cookie-data-use" },
      { label: "Memorial policy", href: "/memorial-policy", id: "memorial-policy" },
      { label: "Official Memorial & Editorial Policy", href: "/official-memorial-policy", id: "official-memorial-policy" },
      { label: "Copyright", href: "/copyright", id: "copyright" },
    ],
  },
  {
    title: "Support & safety",
    links: [
      { label: "Safety", href: "/safety", id: "safety" },
      { label: "Account deletion", href: "/account-deletion", id: "account-deletion" },
      { label: "Privacy request", href: "/privacy-request", id: "privacy-request" },
      { label: "Contact", href: "/contact", id: "contact" },
    ],
  },
];

export const HOME_META = {
  title: "Vmemoo — Remember People, Pets & Memories",
  description: SITE.description,
};
